import { WellDoneProvider } from './WellDonePageContext';
import WellDoneScreenContainer from '../../containers/WellDoneScreenContainer';

export default function WellDonePage() {
  return (
    <WellDoneProvider>
      <WellDoneScreenContainer />
    </WellDoneProvider>
  );
}
